import React, { useContext } from 'react'
import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'
import { Skeleton } from '@frontend/pole-ui/lib/components/Skeleton'
import { ProductsListContext } from '@/pages/Financing/constants'
import { FinancingProductOther } from './components/FinancingProductOther'
import { messages } from './messages'
import type { IFinancingProductsOtherProps } from './types'
import './styles.scss'

const SKELETONS: TSkeletons = Array(9).fill({ height: 387 })

export const FinancingProductsOther: React.FC<IFinancingProductsOtherProps> = ({ isVisible }) => {
  const { products, isLoading, otherProductsList } = useContext(ProductsListContext)

  if (!isVisible || products.otherProducts.length < 1) {
    return null
  }

  return (
    <div className="financingProductsOther" ref={otherProductsList?.blockRef}>
      <div className="financingProductsOther__title">
        <h2>{messages.title}</h2>
      </div>
      <div className="financingProductsOther__list">
        <Skeleton skeletons={SKELETONS} isLoading={isLoading}>
          {products.otherProducts.map(product => (
            <FinancingProductOther key={product.productId} product={product} />
          ))}
        </Skeleton>
      </div>
    </div>
  )
}
